import React from "react"
import { AnchorLink } from "gatsby-plugin-anchor-links"
import PropTypes from "prop-types"

const PostDirectory = ({ post, customClass = "", tagName, setTagName }) => {
  const SectionItem = ({ title, slug }) => {
    const isActive = title === tagName

    return (
      <li
        className={`px-2 py-2 hover:underline ${isActive ? "bg-gray-200" : ""}`}
        onClick={() => setTagName(title)}
      >
        <AnchorLink to={slug}>{title}</AnchorLink>
      </li>
    )
  }

  SectionItem.propTypes = {
    title: PropTypes.string,
    slug: PropTypes.string,
  }

  return (
    <div
      className={`lg:w-52 xl:w-full bg-gray-100 lg:bg-white text-gray-900 p-3 lg:pr-6 ${customClass}`}
    >
      <p className="leading-normal tracking-wide font-bold text-2xl gradient max-w-max hidden lg:block">
        快速跳轉目錄
      </p>
      <div className="space-y-3 text-base leading-normal list-decimal lg:ml-6 lg:mt-8">
        {post?.contents.map(content => {
          if (content.displayTitle === true) {
            return (
              <SectionItem
                key={content.id}
                title={content.title}
                slug={`/blog/${post.slug}#contentid-${content.id}`}
                id={content.id}
              />
            )
          }
        })}
      </div>
    </div>
  )
}

PostDirectory.propTypes = {
  post: PropTypes.object,
  customClass: PropTypes.string,
  tagName: PropTypes.string,
  setTagName: PropTypes.func,
}

export default PostDirectory
